import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Text,
    Button,
    HStack,
} from '@chakra-ui/react';

export interface InvoiceChangeVendorModalProps {
    isOpen: boolean;
    onClose: () => void;
    isLoading: boolean;
    currentVendor: string;
    nextVendor: string;
    onConfirm: () => void;
}

const InvoiceChangeVendorModal = ({
    isOpen,
    onClose,
    isLoading,
    currentVendor,
    nextVendor,
    onConfirm,
}: InvoiceChangeVendorModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="md">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader fontSize="xl" fontWeight="bold" color="gray.900">
                    Change vendor?
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={4}>
                    <Text fontSize="md" color="gray.600" mb={3}>
                        Are you sure you want to change the vendor from <strong>{currentVendor || '—'}</strong> to{' '}
                        <strong>{nextVendor || '—'}</strong>?
                    </Text>
                    <Text fontSize="md" color="gray.600">
                        The invoice will re-reconcile with the new vendor (NEX matching, markup/discount rules, flags,
                        and totals).
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={3}>
                        <Button size="action" variant="outlineGray" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button size="action"
                            bg="#0071E3"
                            color="white"
                            _hover={{ bg: '#3544a0' }} onClick={onConfirm} isLoading={isLoading} loadingText="Updating…">
                            Change vendor and reconcile
                        </Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default InvoiceChangeVendorModal;
